import { Stack, usePathname } from 'expo-router';

import PlatformContainer from '@/components/web/PlatformContainer';
import { useAuth } from '@/contexts/authContext';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { StyleSheet, View } from 'react-native';

const ProfileLayout = () => {
  const {
    state: { user }
  } = useAuth();

  const { top } = useSafeAreaInsets();
  const path = usePathname();

  const shouldNotOverScroll = path.includes('transactions') || path.includes('subscriptions');

  return (
    <PlatformContainer
      contentCustomClassnames={'flex flex-col'}
      containerCustomClassname={shouldNotOverScroll ? '' : 'overscroll-contain'}
      overflowY={!shouldNotOverScroll}>
      <View style={styles.flexOne}>
        <Stack
          screenOptions={{
            headerShown: false,
            headerShadowVisible: false,
            headerBackVisible: false
          }}>
          <Stack.Screen
            name={!user?.user ? 'browseOnly' : user.user?.role === 'NON_PROFIT_ORG' ? 'npoProfile' : 'individual'}
          />
          <Stack.Screen name="settings" />
        </Stack>
      </View>
    </PlatformContainer>
  );
};

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  }
});

export default ProfileLayout;
